import { render, staticRenderFns } from "./objectsCompareView.vue?vue&type=template&id=e2bd98d0&"
import script from "./objectsCompareView.vue?vue&type=script&lang=js&"
export * from "./objectsCompareView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports